import React from "react";
import { Link } from "react-router-dom";

const Notfound = () => {
  return (
    <div className="notfound-wrap">
      <div>
        <span className="big-four">4</span>
        <span className="second-four">4</span>
      </div>
      <p className="wrong-para">Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="btn btn-primary" style={{ marginTop: 20 }}>
        Go Home
      </Link>
    </div>
  );
};

export default Notfound;